import { create } from "@/modules/core/store"
import type { UserProgramItemEntity } from "@/modules/programs/entities/userProgramItemEntity"

type TrainingProgramFilterActions = {
  initSelectedPrograms: (programs: UserProgramItemEntity[]) => void
  addSelectedProgram: (program: UserProgramItemEntity) => void
  addFilteredPrograms: (programs: UserProgramItemEntity[]) => void
  removeSelectedProgram: (program: UserProgramItemEntity) => void
  clearSelectedPrograms: () => void
}

type TrainingProgramFilterState = {
  selectedPrograms: UserProgramItemEntity[]
  actions: TrainingProgramFilterActions
}

const useTrainingProgramFilterStore = create<TrainingProgramFilterState>()((set, get) => ({
  selectedPrograms: [],
  actions: {
    initSelectedPrograms: (programs: UserProgramItemEntity[]) => set({ selectedPrograms: programs }),
    addSelectedProgram: (program: UserProgramItemEntity) =>
      set({ selectedPrograms: [...get().selectedPrograms, program] }),
    addFilteredPrograms: (programs: UserProgramItemEntity[]) =>
      set({ selectedPrograms: [...get().selectedPrograms, ...programs] }),
    removeSelectedProgram: (program: UserProgramItemEntity) =>
      set({ selectedPrograms: get().selectedPrograms.filter((p) => p.id !== program.id) }),
    clearSelectedPrograms: () => set({ selectedPrograms: [] }),
  },
}))

export const useTrainingProgramFilter = () => useTrainingProgramFilterStore((state) => state.selectedPrograms)
export const useTrainingProgramFilterActions = () => useTrainingProgramFilterStore((state) => state.actions)
